export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none" {...props}>
            <path
                d="M13.343 41.9943L14.0044 43.1541C14.0906 43.3092 14.1457 43.4799 14.1665 43.6566C14.1874 43.8332 14.1735 44.0122 14.1258 44.1834C14.0781 44.3546 13.9974 44.5147 13.8885 44.6543C13.7795 44.7939 13.6444 44.9104 13.4908 44.9971C13.3378 45.0844 13.2033 45.2014 13.0951 45.3413C12.9868 45.4812 12.9069 45.6413 12.8598 45.8125C12.8128 45.9836 12.7995 46.1625 12.8209 46.3388C12.8422 46.5151 12.8977 46.6855 12.9842 46.8401L13.6456 48"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.0761 48L22.4147 46.8401C22.3285 46.6851 22.2734 46.5143 22.2526 46.3377C22.2317 46.1611 22.2456 45.982 22.2933 45.8108C22.341 45.6396 22.4217 45.4796 22.5306 45.34C22.6396 45.2004 22.7748 45.0838 22.9283 44.9971C23.0819 44.9104 23.217 44.7939 23.326 44.6543C23.435 44.5147 23.5156 44.3546 23.5633 44.1834C23.6111 44.0122 23.6249 43.8332 23.6041 43.6566C23.5832 43.4799 23.5281 43.3092 23.442 43.1541L22.7805 41.9943"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M32.5542 48L31.8927 46.8401C31.8063 46.6855 31.7508 46.5151 31.7294 46.3388C31.7081 46.1625 31.7213 45.9836 31.7684 45.8125C31.8154 45.6413 31.8954 45.4812 32.0036 45.3413C32.1119 45.2014 32.2464 45.0844 32.3994 44.9971C32.5536 44.9111 32.6894 44.795 32.7989 44.6554C32.9084 44.5159 32.9894 44.3557 33.0372 44.1843C33.085 44.0128 33.0986 43.8334 33.0773 43.6566C33.056 43.4798 33.0001 43.309 32.913 43.1541L32.2235 41.9943"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M42.0038 48L41.3706 46.8401C41.2844 46.6851 41.2293 46.5143 41.2085 46.3377C41.1876 46.1611 41.2015 45.982 41.2492 45.8108C41.2969 45.6396 41.3776 45.4796 41.4865 45.34C41.5955 45.2004 41.7307 45.0838 41.8842 44.9971C42.0378 44.9104 42.1729 44.7939 42.2819 44.6543C42.3909 44.5147 42.4715 44.3546 42.5192 44.1834C42.567 44.0122 42.5808 43.8332 42.56 43.6566C42.5392 43.4799 42.4841 43.3092 42.3979 43.1541L41.7365 41.9943"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M51.4564 48L50.795 46.8401C50.7085 46.6855 50.653 46.5151 50.6317 46.3388C50.6104 46.1625 50.6236 45.9836 50.6706 45.8125C50.7177 45.6413 50.7976 45.4812 50.9059 45.3413C51.0142 45.2014 51.1486 45.0844 51.3016 44.9971C51.4559 44.9111 51.5917 44.795 51.7012 44.6554C51.8107 44.5159 51.8917 44.3557 51.9395 44.1843C51.9873 44.0128 52.0009 43.8334 51.9796 43.6566C51.9582 43.4798 51.9024 43.309 51.8153 43.1541L51.1539 41.9943"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.69498 16.7036H57.305C58.394 16.7036 59.2964 17.6042 59.2964 18.7396V35.17C59.2964 36.3053 58.394 37.2059 57.305 37.2059H6.69498C5.60602 37.2059 4.70362 36.3053 4.70362 35.17V18.7396C4.70362 17.6042 5.60602 16.7036 6.69498 16.7036Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M11.7896 37.206V34.0369H52.058V37.206H11.7896Z" stroke="black" strokeWidth="1.40725" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5 30.1583L59 30.1583" stroke="black" strokeWidth="1.40725" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.01163 25.4349H13.5764" stroke="black" strokeWidth="1.40725" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.8541 25.4349H18.6194" stroke="black" strokeWidth="1.40725" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
